
export const FILTERS = {
  DAILY: {
    label: "Daily",
  },
  WEEKLY: {
    label: "Weekly",
  },
  MONTHLY: {
    label: "Monthly",
  },
  YEARLY: {
    label: "Yearly",
    filter: (graphData) => {
      // const today = new Date();
      // return graphData.filter((d) => dateFns.differenceInDays(today, new Date(d.name)) < 365);

      // Keep only last 12 months (might not up to date if data is stale)
      return graphData.slice(-12);
    },
    filterPreviousExercise: (graphData) => {
      return graphData.slice(-24, -13);
    }
  },
  ALL_TIME: {
    label: "All Time",
    filter: (graphData) => graphData,
    filterPreviousExercise: () => []
  },
  CUSTOM: {
    label: "Custom",
  },
}
